import { useState } from 'react';
import { StepDefinition } from '../types/components';

export const useFormSteps = <T extends object>(steps: StepDefinition[], initialFormData: T, initialStep = 0) => {
  const [currentStep, setCurrentStep] = useState<number>(initialStep);
  const [formData, setFormData] = useState<T>(initialFormData);

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const goToStep = (step: number) => {
    if (step >= 0 && step < steps.length) {
      setCurrentStep(step);
    }
  };

  const updateFormData = (data: Partial<T>) => {
    setFormData(prev => ({ ...prev, ...data }));
  };

  const resetForm = () => {
    setCurrentStep(initialStep);
    setFormData(initialFormData);
  };

  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === steps.length - 1;

  return {
    currentStep,
    formData,
    nextStep,
    prevStep,
    goToStep,
    updateFormData,
    resetForm,
    isFirstStep,
    isLastStep,
    totalSteps: steps.length,
    currentStepData: steps[currentStep],
  };
};
